
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"50.203","height":"30"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"그룹 1751"}},[_c('path',{attrs:{"data-name":"패스 405","d":"M32.286 10.587c-.261.728-2.868 8.026-3.546 9.739a11.3 11.3 0 01-2.6 4.144c-.062-.052-1.541-1.282-1.613-1.347.27-.278 1.9-2 2.1-3.5v-.012l-2.986-8.126a1 1 0 00-.344-.477.792.792 0 00-.376-.164v-.257h2.854l2.06 6.135s1.99-6.072 2.009-6.135zm-12.961 6.89V7.603h-2.7v.312a.41.41 0 01.355.272 1.344 1.344 0 01.141.63v8.828a2.056 2.056 0 002.227 2.192h4.681v-1.952h-4.472c-.077-.001-.232-.001-.232-.408zm22.815-6.626c.277 0 .5.421.5.905v8.08h2.218v-5.509c0-1.517.613-2.258 1.692-2.258s1.441.849 1.441 2.1v5.671h2.213v-6.1c0-2.674-1.181-3.416-2.935-3.416a2.84 2.84 0 00-2.476 1.341h-.047V10.6h-2.6zm-9.108 0c.276 0 .5.421.5.905v8.08h2.217v-5.509c0-1.517.612-2.258 1.691-2.258s1.44.849 1.44 2.1v5.671h2.215v-6.1c0-2.674-1.181-3.416-2.936-3.416a2.837 2.837 0 00-2.474 1.341h-.045V10.6h-2.605z","fill":"#fff"}}),_c('path',{attrs:{"data-name":"패스 406","d":"M23.271 23.823A12.046 12.046 0 0115 27.097a12.11 12.11 0 01-12.093-12.1A12.107 12.107 0 0115 2.903a12.068 12.068 0 0110.605 6.3h3.23l-.05-.118a14.99 14.99 0 00-13.786-9.09 15.015 15.015 0 00-15 15 15.017 15.017 0 0015 15 14.944 14.944 0 0010.26-4.061h.007z","fill":"#f28d1e"}})])])
          )
        }
      }
    